import React from "react";
import { Colors } from "./colors";
import { capitalizeEveryWord } from "../util";

class TextInputAutofill extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      type: props.type || "text",
      isFocused: false,
      failed: false,
      suggestions: [],
      hovered: null,
    };
  }

  componentDidUpdate(prevProps) {
    // Check if the prop has changed
    if (this.props.isfailed !== prevProps.isfailed) {
      // Update the state with the new prop value
      this.setState({
        failed: true,
      });
    }
    if (this.props.value !== prevProps.value) {
      this.setState({
        value: this.props.value,
      });
    }
  }
  handleFocus = () => {
    this.setState({ isFocused: true, failed: false });
    this.filter(this.state.value);
  };
  handleSuggestionClick = (suggestion) => {
    const { listFunc, func } = this.props;
    this.setState({ value: suggestion, suggestions: [] });
    if (listFunc) {
      listFunc(suggestion);
    } else {
      func(suggestion);
    }
  };
  filter = (value) => {
    const { suggestionsList } = this.props;
    const filteredSuggestions = suggestionsList.filter((suggestion) =>
      value == suggestion
        ? null
        : suggestion.toLowerCase().match(value.toLowerCase()),
    );
    const sorted = this.sortByProximity(filteredSuggestions, value);
    this.setState({ suggestions: sorted });
  };
  //sorting criteria for dropdown list
  sortByProximity(array, targetLetter) {
    return array.sort((a, b) => {
      const target = targetLetter.toLowerCase().charCodeAt(0);
      const distanceA = Math.abs(a.toLowerCase().charCodeAt(0) - target);
      const distanceB = Math.abs(b.toLowerCase().charCodeAt(0) - target);

      return distanceA - distanceB;
    });
  }
  handleBlur = () => {
    this.setState({
      isFocused: false,
      failed: this.props.isfailed,
      suggestions: [],
    });
  };

  handleChange = (event) => {
    const { func } = this.props;

    this.setState({ value: event.target.value });
    func(event.target.value);

    this.filter(event.target.value);
  };

  render() {
    const { value, failed, isFocused, type, suggestions, hovered } = this.state;
    const { placeholder, style, dropStyle } = this.props;

    const divStyle = {
      position: "relative",
      margin: "8px",
      height: "100%",
      display: "flex",
      width: "100%",
      flexDirection: "column",
      alignItems: "center",
      flex: this.props.ratio,
    };
    const inputStyle = {
      margin: failed || isFocused ? "0px": '3px',
      padding: "8px",
      width: "100%",
      border: "1px solid #ccc",
      borderRadius: "4px",
      fontSize: "14px",
      outline: "none",
      borderWidth: failed || isFocused ? "4px" : "1px",
      borderColor: isFocused
        ? Colors.lightBlue
        : failed
          ? Colors.brightRed
          : "#ccc",
      transition: " 0.1s ease",
    };

    const listStyle = {
      borderRadius: "4px",
      position: "absolute",
      listStyle: "none",
      padding: "0",
      marginTop: "36px",
      border: "1px solid #ccc",
      backgroundColor: "#fff",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
      zIndex: "5",
      width: "100%",
      display: value && suggestions.length > 0 ? "block" : "none",
    };
    const suggestionItemStyle = {
      padding: "8px",
      cursor: "pointer",
      borderRadius: "4px",
    };
    const suggestionItemHoverStyle = {
      backgroundColor: Colors.lightGray,
    };

    return (
      <div style={divStyle}>
        <input
          type={type}
          style={{ ...inputStyle, ...style }}
          value={value}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          onInput={this.handleChange}
          placeholder={placeholder}
          onKeyDown={this.props.onKeyDown || (() => {})}
        />
        {
          <ul style={{ ...listStyle, ...dropStyle }}>
            {suggestions.slice(0, 8).map((suggestion, index) => (
              <li
                style={{
                  ...suggestionItemStyle,
                  ...(index === hovered ? suggestionItemHoverStyle : {}),
                }}
                key={index}
                onMouseDown={() => this.handleSuggestionClick(suggestion)}
                onMouseEnter={() => this.setState({ hovered: index })}
                onMouseLeave={() => this.setState({ hovered: null })}
              >
                {capitalizeEveryWord(suggestion)}
              </li>
            ))}
          </ul>
        }
      </div>
    );
  }
}

export default TextInputAutofill;
